export type Language = 'fr' | 'ar'

export const translations = {
    fr: {
        appTitle: "Recherche Juridique Maroc",
        searchTab: "Recherche",
        chatTab: "Assistant IA",
        searchPlaceholder: "Rechercher une loi (ex: impôts 2024)...",
        searchButton: "Rechercher",
        searching: "Recherche...",
        loadMore: "Charger plus",
        noResults: "Aucun résultat trouvé.",
        errorGeneric: "Une erreur est survenue.",
        // Sidebar
        categories: "Catégories",
        cat_constitution: "Constitution",
        cat_codes: "Codes Juridiques",
        cat_loi_finances: "Loi de Finances",
        cat_commerce: "Droit Commercial",
        cat_famille: "Droit de la Famille",
        cat_penal: "Droit Pénal",
        cat_travail: "Droit du Travail",
        cat_all: "Tous les documents",
        // Chat
        chatGreeting: "Bonjour ! Je suis votre assistant juridique. Posez-moi une question sur les lois marocaines.",
        chatPlaceholder: "Posez votre question ici...",
        chatSend: "Envoyer",
        chatThinking: "Réflexion...",
        chatError: "Désolé, une erreur est survenue.",
        chatContext: "Contexte utilisé",
        chatRelated: "Questions connexes :",
        chatSources: "Sources",
        chatCopy: "Copier",
        chatCopyAnswer: "Copier la réponse",
        chatDownload: "Télécharger",
        chatClear: "Effacer",
        chatHistory: "Historique",
        chatDisclaimer: "JuriMaroc peut faire des erreurs. Vérifiez les informations importantes.",
        chatNew: "Nouvelle discussion",
        chatRecent: "Récent",
        chatDelete: "Supprimer",
        chatRename: "Renommer la conversation",
        chatUntitled: "Sans titre",
        searchHintTitle: "Recherche juridique",
        searchHintSubtitle: "Entrez un mot-clé pour rechercher des documents officiels.",
        searchSave: "Enregistrer",
        // Profile
        profileTitle: "Complétez votre profil",
        profileSubtitle: "Ces informations nous aident à personnaliser votre expérience.",
        labelFullName: "Nom Complet",
        labelCompanyName: "Nom de l'entreprise",
        labelProfession: "Profession",
        labelPhone: "Numéro de téléphone (WhatsApp)",
        labelCity: "Ville",
        placeholderProfession: "Sélectionnez votre profession",
        placeholderPhone: "ex: 0600000000",
        placeholderCity: "ex: Casablanca",
        submitProfile: "Enregistrer",
        btnResetPassword: "Réinitialiser le mot de passe",
        msgPasswordResetSent: "Un email de réinitialisation a été envoyé à {email}.",
        titleProfilePage: "Mon Profil",
        prof_lawyer: "Avocat / Juriste",
        prof_corporate: "Entreprise / RH",
        prof_student: "Étudiant / Académique",
        prof_individual: "Particulier",
        prof_other: "Autre",
        // User Menu
        menuProfile: "Mon Profil",
        menuLogout: "Déconnexion",
        menuLogin: "Connexion",
        // Upgrade
        upgradeTitle: "Passez à la version Premium",
        upgradeDesc: "Vous avez atteint votre limite quotidienne gratuite. Passez à la version Premium pour un accès illimité.",
        upgradeCancel: "Plus tard",
        upgradeConfirm: "Confirmer la commande",
        upgradeStep1: "Détails de la commande",
        upgradeStep2: "Paiement",
        upgradeStep3: "Preuve de paiement",
        bankDetails: "Coordonnées Bancaires",
        bankName: "Banque",
        bankAccount: "RIB",
        bankBeneficiary: "Bénéficiaire",
        uploadReceipt: "Télécharger le reçu",
        uploadHint: "Veuillez télécharger une photo ou un PDF de votre virement.",
        uploadButton: "Sélectionner un fichier",
        uploading: "Envoi en cours...",
        orderCreated: "Commande créée",
        pendingApproval: "Votre abonnement est en attente de validation. Vous serez notifié une fois activé.",
        checkingOrders: "Vérification des commandes en cours...",
        pendingOrderTitle: "Commande déjà en cours",
        pendingOrderNotice: "Vous avez déjà démarré une commande. Merci de téléverser votre reçu pour finaliser l'activation.",
        pendingOrderReview: "Nous vérifierons le reçu et activerons votre abonnement sous peu.",
        priceLabel: "Prix",
        priceValue: "200 DH / Mois",
        planBenefits: "Accès illimité, Recherche avancée, Support prioritaire",
        planFreeLabel: "Plan gratuit",
        planPremiumLabel: "Premium actif",
        planUpgradeCta: "Passer Premium",
        // Trial
        trialBanner: "{days} jours restants dans votre essai",
        trialBannerLastDay: "Dernier jour de votre essai",
        trialBannerExpired: "Votre essai est terminé",
        trialUsage: "{used}/{limit} recherches aujourd'hui",
        trialUpgradeCta: "Passer Premium",
        trialBenefits: "25 recherches/jour pendant l'essai",
        trialEndingSoon: "Votre essai se termine dans {days} jours",
        trialEnded: "Votre période d'essai est terminée",
        trialKeepAccess: "Passez à un accès illimité",
        planTrialLabel: "Essai Gratuit",
        // Onboarding modal
        welcomeTitle: "Bienvenue sur JuriMaroc !",
        welcomeSubtitle: "Votre assistant juridique marocain propulsé par l'IA",
        trialExplanation: "Profitez de 5 jours d'essai gratuit avec 25 recherches par jour.",
        freeAfterTrial: "Après l'essai, vous aurez 5 recherches gratuites par jour.",
        premiumExplanation: "Passez à Premium pour un accès illimité et un support prioritaire.",
        startTrial: "Démarrer mon essai",
        // Auth modal
        signIn: "Se connecter",
        signUp: "Créer un compte",
        email: "Email",
        password: "Mot de passe",
        confirmPassword: "Confirmer le mot de passe",
        continueWithGoogle: "Continuer avec Google",
        orContinueWith: "ou continuer avec",
        alreadyHaveAccount: "Déjà un compte ?",
        noAccount: "Pas de compte ?",
        signInLink: "Se connecter",
        signUpLink: "S'inscrire",
        passwordMismatch: "Les mots de passe ne correspondent pas",
        passwordTooShort: "Le mot de passe doit contenir au moins 6 caractères",
        invalidEmail: "Email invalide",
        emailInUse: "Cet email est déjà utilisé",
        wrongPassword: "Mot de passe incorrect",
        userNotFound: "Aucun compte trouvé avec cet email",
        verifyEmail: "Vérifiez votre email",
        verifyEmailMessage: "Un email de vérification a été envoyé à {email}. Veuillez cliquer sur le lien pour activer votre compte.",
        resendVerification: "Renvoyer l'email",
        emailVerified: "Email vérifié !",
    },
    ar: {
        appTitle: "البحث القانوني المغربي",
        searchTab: "بحث",
        chatTab: "المساعد الذكي",
        searchPlaceholder: "ابحث عن قانون (مثال: الضرائب 2024)...",
        searchButton: "بحث",
        searching: "جاري البحث...",
        loadMore: "تحميل المزيد",
        noResults: "لا توجد نتائج.",
        errorGeneric: "حدث خطأ ما.",
        // Sidebar
        categories: "التصنيفات",
        cat_constitution: "الدستور",
        cat_codes: "المدونات القانونية",
        cat_loi_finances: "قانون المالية",
        cat_commerce: "القانون التجاري",
        cat_famille: "قانون الأسرة",
        cat_penal: "القانون الجنائي",
        cat_travail: "قانون الشغل",
        cat_all: "كل الوثائق",
        // Chat
        chatGreeting: "مرحباً! أنا مساعدك القانوني. اسألني أي سؤال حول القوانين المغربية.",
        chatPlaceholder: "اطرح سؤالك هنا...",
        chatSend: "إرسال",
        chatThinking: "جاري التفكير...",
        chatError: "عذراً، حدث خطأ.",
        chatContext: "المصادر المستخدمة",
        chatRelated: "أسئلة مقترحة:",
        chatSources: "المصادر",
        chatCopy: "نسخ",
        chatCopyAnswer: "نسخ الإجابة",
        chatDownload: "تنزيل",
        chatClear: "مسح",
        chatHistory: "السجل",
        chatDisclaimer: "يمكن لـ JuriMaroc أن يرتكب أخطاء. تحقق من المعلومات المهمة.",
        chatNew: "محادثة جديدة",
        chatRecent: "الأخيرة",
        chatDelete: "حذف",
        chatRename: "تغيير الاسم",
        chatUntitled: "بدون عنوان",
        searchHintTitle: "بحث قانوني",
        searchHintSubtitle: "أدخل كلمة مفتاحية للبحث في الوثائق الرسمية.",
        searchSave: "حفظ",
        // Profile
        profileTitle: "أكمل ملفك الشخصي",
        profileSubtitle: "تساعدنا هذه المعلومات في تحسين تجربتك.",
        labelFullName: "الاسم الكامل",
        labelCompanyName: "اسم الشركة",
        labelProfession: "المهنة",
        labelPhone: "رقم الهاتف (واتساب)",
        labelCity: "المدينة",
        placeholderProfession: "اختر مهنتك",
        placeholderPhone: "مثال: 0600000000",
        placeholderCity: "مثال: الدار البيضاء",
        submitProfile: "حفظ",
        btnResetPassword: "إعادة تعيين كلمة المرور",
        msgPasswordResetSent: "تم إرسال رابط إعادة تعيين كلمة المرور إلى {email}.",
        titleProfilePage: "ملفي الشخصي",
        prof_lawyer: "محامي / قانوني",
        prof_corporate: "شركة / موارد بشرية",
        prof_student: "طالب / أكاديمي",
        prof_individual: "فرد",
        prof_other: "آخر",
        // User Menu
        menuProfile: "ملفي الشخصي",
        menuLogout: "تسجيل الخروج",
        menuLogin: "تسجيل الدخول",
        // Upgrade
        upgradeTitle: "الترقية إلى النسخة المميزة",
        upgradeDesc: "لقد وصلت إلى الحد اليومي المجاني. قم بالترقية للحصول على وصول غير محدود.",
        upgradeCancel: "لاحقاً",
        upgradeConfirm: "تأكيد الطلب",
        upgradeStep1: "تفاصيل الطلب",
        upgradeStep2: "الدفع",
        upgradeStep3: "إثبات الدفع",
        bankDetails: "بيانات التحويل البنكي",
        bankName: "البنك",
        bankAccount: "رقم الحساب (RIB)",
        bankBeneficiary: "المستفيد",
        uploadReceipt: "تحميل الإيصال",
        uploadHint: "يرجى تحميل صورة أو ملف PDF لإيصال التحويل.",
        uploadButton: "اختيار ملف",
        uploading: "جاري الرفع...",
        orderCreated: "تم إنشاء الطلب",
        pendingApproval: "اشتراكك قيد المراجعة. سيتم إشعارك بمجرد التفعيل.",
        checkingOrders: "جارٍ التحقق من الطلبات الحالية...",
        pendingOrderTitle: "طلب قيد المعالجة",
        pendingOrderNotice: "لديك طلب سابق لم يتم إكماله بعد. يرجى رفع وصل التحويل لإتمام الترقية.",
        pendingOrderReview: "سنراجع الوصل ونفعّل اشتراكك في أقرب وقت.",
        priceLabel: "السعر",
        priceValue: "200 درهم / شهر",
        planBenefits: "وصول غير محدود، بحث متقدم، دعم ذو أولوية",
        planFreeLabel: "خطة مجانية",
        planPremiumLabel: "الخطة المميزة",
        planUpgradeCta: "الترقية الآن",
        // Trial
        trialBanner: "{days} أيام متبقية في فترة التجربة",
        trialBannerLastDay: "آخر يوم في فترة التجربة",
        trialBannerExpired: "انتهت فترة التجربة",
        trialUsage: "{used}/{limit} عملية بحث اليوم",
        trialUpgradeCta: "الترقية الآن",
        trialBenefits: "25 عملية بحث يومياً خلال فترة التجربة",
        trialEndingSoon: "فترة التجربة تنتهي خلال {days} أيام",
        trialEnded: "انتهت فترة التجربة المجانية",
        trialKeepAccess: "انتقل إلى وصول غير محدود",
        planTrialLabel: "تجربة مجانية",
        // Onboarding modal
        welcomeTitle: "مرحباً بك في JuriMaroc!",
        welcomeSubtitle: "مساعدك القانوني المغربي بالذكاء الاصطناعي",
        trialExplanation: "استمتع بـ 5 أيام تجربة مجانية مع 25 عملية بحث يومياً.",
        freeAfterTrial: "بعد التجربة، ستحصل على 5 عمليات بحث مجانية يومياً.",
        premiumExplanation: "انتقل إلى بريميوم للحصول على وصول غير محدود ودعم أولوي.",
        startTrial: "ابدأ التجربة",
        // Auth modal
        signIn: "تسجيل الدخول",
        signUp: "إنشاء حساب",
        email: "البريد الإلكتروني",
        password: "كلمة المرور",
        confirmPassword: "تأكيد كلمة المرور",
        continueWithGoogle: "المتابعة باستخدام Google",
        orContinueWith: "أو المتابعة بـ",
        alreadyHaveAccount: "لديك حساب بالفعل؟",
        noAccount: "ليس لديك حساب؟",
        signInLink: "تسجيل الدخول",
        signUpLink: "إنشاء حساب",
        passwordMismatch: "كلمات المرور غير متطابقة",
        passwordTooShort: "يجب أن تحتوي كلمة المرور على 6 أحرف على الأقل",
        invalidEmail: "بريد إلكتروني غير صالح",
        emailInUse: "هذا البريد الإلكتروني مستخدم بالفعل",
        wrongPassword: "كلمة المرور غير صحيحة",
        userNotFound: "لا يوجد حساب بهذا البريد الإلكتروني",
        verifyEmail: "تحقق من بريدك الإلكتروني",
        verifyEmailMessage: "تم إرسال رسالة تحقق إلى {email}. يرجى النقر على الرابط لتفعيل حسابك.",
        resendVerification: "إعادة إرسال البريد",
        emailVerified: "تم التحقق من البريد الإلكتروني!",
    },
} as const

export type Translation = (typeof translations)[Language]

